/**
 * Parses a date string and returns a Date object if valid, otherwise null.
 * @param dateStr - The date string to parse.
 * @returns A Date object or null if invalid.
 */
export function getValidDateOrNull(
  dateStr: string | null | undefined
): Date | null {
  if (!dateStr) return null;

  const date = new Date(dateStr);
  return isNaN(date.getTime()) ? null : date;
}
